import {CreateTreeNode} from "../view-model";

export const cloneHierarchy = <T extends CreateTreeNode<T>>(
  hierarchy: T
): T => {
  return {
    ...hierarchy,
    children: hierarchy.children.map(cloneHierarchy)
  };
};
